<template>
  <div class="container fade-in">
    <div class="min-vh-100 d-flex justify-content-center align-content-center">
      <div class="m-auto col-lg-8">
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <div v-if="loading" class="loading-container">
                <RotateSquare
                  class="loading-position animated fadeIn"
                  size="60px"
                ></RotateSquare>
              </div>
              <div v-else-if="tokenInvalido">
                <h3>Link Inválido</h3>
                <p class="text-muted">
                  O link de recuperação é inválido ou expirou.
                </p>
                <div class="d-flex align-content-around mt-5">
                  <button
                    class="btn btn-primary mr-auto"
                    @click="solicitarNovamente"
                  >
                    Solicitar novo link
                  </button>
                  <button
                    class="btn btn-link"
                    @click="$router.push('/login')"
                  >
                    Voltar
                  </button>
                </div>
              </div>
              <form v-else-if="step === 'success'" @submit.prevent>
                <h3>Recuperar Senha</h3>
                <p>
                  Foi enviado um link de recuperação para seu e-mail.
                </p>
                <div class="d-flex align-content-around mt-5">
                  <button
                    class="btn btn-link"
                    @click="$router.push('/login')"
                  >
                    Voltar para o Login
                  </button>
                </div>
              </form>
              <form v-else-if="step === 'reset'" @submit="onSubmitReset">
                <h1>Nova Senha</h1>
                <p class="text-muted">Informe a nova senha abaixo.</p>
                <div class="d-flex flex-column">
                  <div class="input-group mb-3">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <CIcon name="cil-lock-locked" />
                      </span>
                    </div>
                    <input
                      v-model="newPassword"
                      type="password"
                      class="form-control"
                      placeholder="Nova Senha"
                      required
                    />
                  </div>

                  <div class="input-group mb-3">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <CIcon name="cil-lock-locked" />
                      </span>
                    </div>
                    <input
                      v-model="confirmPassword"
                      type="password"
                      class="form-control"
                      placeholder="Confirmar Nova Senha"
                      required
                    />
                  </div>
                </div>
                <div class="d-flex align-content-around mt-5">
                  <button class="btn btn-primary mr-auto" type="submit">
                    Trocar Senha
                  </button>
                  <button
                    class="btn btn-link"
                    @click="$router.push('/login')"
                  >
                    Voltar
                  </button>
                </div>
              </form>
              <form v-else @submit="onSubmitRequest">
                <h3>Recuperar Senha</h3>
                <p class="text-muted">
                  Digite um e-mail para continuar a recuperação da senha.
                </p>
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <CIcon name="cil-envelope-closed" />
                    </span>
                  </div>
                  <input
                    v-model="email"
                    type="email"
                    class="form-control"
                    placeholder="E-mail"
                    autocomplete="username email"
                    required
                  />
                </div>
                <div class="d-flex align-content-around mt-5">
                  <button class="btn btn-primary mr-auto" type="submit">
                    Enviar
                  </button>
                  <button
                    class="btn btn-link"
                    @click="$router.push('/login')"
                  >
                    Voltar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="card text-center py-5 d-md-down-none bg-primary text-white"
          >
            <h2>Ainda não tem uma conta?</h2>
            <p class="m-5">
              Entre em contato com nossa equipe de vendas para maiores
              informações.
            </p>
            <div>
              <a
                href="https://arboran.com.br"
                target="_blank"
                class="btn btn-primary active mt-3"
              >
                Contratar agora!
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import PasswordRecoveryServico from "../../servico/PasswordRecoveryServico";

export default {
  name: "ForgotPassword",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      step: "request",
      token: "",
      tokenInvalido: false,
      email: "",
      newPassword: "",
      confirmPassword: ""
    };
  },
  mounted() {
    const token = this.$route.query.token;
    if (token) {
      this.token = token;
      this.validarToken();
    }
  },
  methods: {
    validarToken() {
      this.loading = true;
      PasswordRecoveryServico.ValidarToken(this.token)
        .then(() => {
          this.loading = false;
          this.step = "reset";
        })
        .catch(() => {
          this.loading = false;
          this.tokenInvalido = true;
        });
    },
    solicitarNovamente() {
      this.tokenInvalido = false;
      this.token = "";
      this.step = "request";
    },
    onSubmitRequest(event) {
      event.preventDefault();
      this.loading = true;
      PasswordRecoveryServico.SolicitarRecuperacao({ email: this.email })
        .then(() => {
          this.loading = false;
          this.step = "success";
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    onSubmitReset(event) {
      event.preventDefault();
      if (this.newPassword !== this.confirmPassword) {
        this.$notify({
          data: ["As senhas não coincidem."],
          type: "warn",
          duration: 5000
        });
        return;
      }
      if (this.newPassword.length < 6) {
        this.$notify({
          data: ["A senha deve ter no mínimo 6 caracteres."],
          type: "warn",
          duration: 5000
        });
        return;
      }
      this.loading = true;
      PasswordRecoveryServico.RedefinirSenha({
        token: this.token,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword
      })
        .then(() => {
          this.loading = false;
          this.$notify({
            data: ["Senha atualizada com sucesso."],
            type: "success",
            duration: 5000
          });
          this.$router.push("/login");
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
